import { IOS, ANDROID, HUAWEI } from '../utils/constants';

const CLOSE_EVENT = 'CLOSE';

const OS_CLOSE_FUNCTIONS = {
  [IOS]: (payload = {}) => iOSCloseFunction(payload),
  [ANDROID]: (payload = {}) => androidCloseFunction(payload),
  [HUAWEI]: (payload = {}) => androidCloseFunction(payload),
};

const closeFunction = () => {
  // This is intentional
};

const iOSCloseFunction = (payload = {}) => {
  if (window.webkit && window.webkit.messageHandlers) {
    window.webkit.messageHandlers.ListenEventsInterface.postMessage({
      event: CLOSE_EVENT,
      payload,
    });
  }
};

const androidCloseFunction = (payload = {}) => {
  window.GenericLandingEvents.sendEvents(
    JSON.stringify({
      event: CLOSE_EVENT,
      payload,
    }),
  );
};

const useCloseFunction = (platform) => ({
  closeFn: OS_CLOSE_FUNCTIONS[platform] || closeFunction,
});

export default useCloseFunction;
